// extracted by mini-css-extract-plugin
module.exports = {"pagination-button":"Pagination_pagination-button__EIQ04"};